import axios from 'axios'
import { setupAxios } from '../app/modules/auth'
import { API_BASE_URL } from '../utils/contants'

const API_EMPLOYEE_SHIFT = 'employee-shift'

// Assign Shift
export const assignEmployeeShiftAPI =
  async (data: {
    employeeId: string
    shiftId: string
    effectiveFrom: string
    effectiveTo?: string | null
    assignedBy?: string
    notes?: string
  }) => {

    const { token } = setupAxios()

    try {

      const response = await axios.post(
        `${API_BASE_URL}/${API_EMPLOYEE_SHIFT}/assign`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      return response.data

    } catch (error) {

      console.error(
        'Error assigning employee shift:',
        error
      )

      throw error
    }
  }

// Current Shift
export const getCurrentEmployeeShiftAPI =
  async (employeeId: string) => {

    const { token } = setupAxios()

    try {

      const response = await axios.get(
        `${API_BASE_URL}/${API_EMPLOYEE_SHIFT}/current/${employeeId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      return response.data

    } catch (error) {

      console.error(error)

      throw error
    }
  }

// Shift History
export const getEmployeeShiftHistoryAPI =
  async (employeeId: string) => {

    const { token } = setupAxios()

    try {

      const response = await axios.get(
        `${API_BASE_URL}/${API_EMPLOYEE_SHIFT}/history/${employeeId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      return response.data

    } catch (error) {

      console.error(error)

      throw error
    }
  }

  // Temporary Shift Users
// Temporary Shift Users
export const getTemporaryShiftUsersAPI =
  async (
    page: number,
    limit: number,
    search: string,
    onlyAssigned: boolean = false
  ) => {

    const { token } = setupAxios();

    try {

      const response =
        await axios.get(
          `${API_BASE_URL}/${API_EMPLOYEE_SHIFT}/temporary-users?page=${page}&limit=${limit}&search=${search}&onlyAssigned=${onlyAssigned}`,
          {
            headers: {
              Authorization:
                `Bearer ${token}`,
            },
          }
        );

      return response.data;

    } catch (error) {

      console.error(error);

      throw error;
    }
  };